import Toast from 'src/components/Toast'
import {useToast} from 'src/context/ToastContext'
import {Grid} from 'src/components/Box'

const ToastMessages = () => {
  const toasts = useToast()
  return (
    <Grid
      gridGap="2"
      css={(theme) => ({
        marginTop: theme.space[2],
      })}
    >
      {toasts.map(({body, key, clear}) => (
        <Toast key={key} body={body} clear={clear} />
      ))}
    </Grid>
  )
}

export default ToastMessages
